import { ModalWrapper } from "../../../components/ModalWrapper";
import { SignalReportSubmissionCard } from "../../../components";
import ConductCheckDataReview from "./ConductCheckDataReview";

export const ConductCheckReviewModal = ({ contentData, onClose }) => {
  const isOpen = !!contentData;

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <ModalWrapper
      title="ConductCheck hit(s) report"
      isOpen={isOpen}
      onClose={handleCloseModal}
    >
      <SignalReportSubmissionCard data={contentData} />
      <ConductCheckDataReview data={contentData} />
    </ModalWrapper>
  );
};
